import { useTranslation } from 'react-i18next';

import { InfoSection, InfoSectionWrapper, StyledTitle } from 'components/containers/InfoSection';

export const ResetPasswordError = () => {
  const { t } = useTranslation('account');

  return (
    <InfoSectionWrapper>
      <InfoSection onSuccess={false} />
      <StyledTitle>{t('password.password-change-error')}</StyledTitle>
    </InfoSectionWrapper>
  );
};
